"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLeadingZero = void 0;
exports.isNumber = isNumber;

/**
 * method to understand if an element is a number
 * @param {any} element Any parameter to check if is a number or not
 */
function isNumber(element) {
  return !!(typeof element === 'number');
}
/**
 * method to add leading zero to a number
 * @param {number | string} number number to be added leading zeroes
 * @param {number} maxLength number of digits of the final expected number
 */


var addLeadingZero = function addLeadingZero(number, maxLength) {
  return String(number).padStart(maxLength, '0');
};

exports.addLeadingZero = addLeadingZero;